module.exports = __webpack_public_path__ + "img/bYlxRfyM.bcfa6302.svg";